import { render, staticRenderFns } from "./WarehouseItemsMatrix.vue?vue&type=template&id=788c5363&scoped=true&"
import script from "./WarehouseItemsMatrix.vue?vue&type=script&lang=js&"
export * from "./WarehouseItemsMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c5363",
  null
  
)

export default component.exports